
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-js-5-connecting-server-and-database.json") })
        }
      }, "path---graphql-js-5-connecting-server-and-database");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-js-5-connecting-server-and-database!./.cache/json/graphql-js-5-connecting-server-and-database.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-js-5-connecting-server-and-database!./.cache/json/graphql-js-5-connecting-server-and-database.json
// module chunks = 154